<template>
  <asc-label size="sm" :value="value"></asc-label>
</template>

<script>
import AscLabel from '@/components/atoms/AscLabel'

export default {
  name: 'AscReportNote',

  components: {
    AscLabel,
  },

  props: {
    value: {
      type: String,
      required: true,
    },
  },
}
</script>
